export const newsData = [
  {
    id: 1,
    date: '2025.01.15',
    title: '新春キャンペーン開始のお知らせ - オーダーメイドジュエリー10%OFF',
  },
  {
    id: 2,
    date: '2025.01.08',
    title: '冬季休業のお知らせ（1月1日〜1月3日）',
  },
  {
    id: 3,
    date: '2024.12.20',
    title: 'ブライダルフェア開催のご案内 - 結婚指輪・婚約指輪の特別展示会',
  },
  {
    id: 4,
    date: '2024.12.10',
    title: '年末年始の営業時間変更について',
  },
];